// extracted by mini-css-extract-plugin
module.exports = {"main":"ErrorMessage_main__2j-Oi","errorIcon":"ErrorMessage_errorIcon__T8bGQ","hiddenMessage":"ErrorMessage_hiddenMessage__3w2tL"};